import { UseFormGetValues } from 'react-hook-form'
import { Alert } from '../../../../../components/alerts/Alert'
import { TAutorizacionForm } from '../../../models/autorizacionForm.type'

type Props = {
  getValues: UseFormGetValues<TAutorizacionForm>
}
export const AlertFechaVencimiento = ({ getValues }: Props) => {
  // Mensajeria contextual para modo "fecha de vencimiento":
  // se muestra cuando falta fecha de emision y/o fecha de vencimiento.
  return (
    <div className='  col-10 '>
      <Alert
        color='dark'
        mensaje={`${
          !getValues('fechaEmision') && !getValues('fechaVencimiento')
            ? 'Selecciona una fecha de emisión y una fecha de vencimiento'
            : getValues('fechaEmision') && !getValues('fechaVencimiento')
            ? 'Selecciona una fecha de vencimiento'
            : !getValues('fechaEmision') && getValues('fechaVencimiento')
            ? 'Selecciona una fecha de emisión'
            : ''
        }.`}
      />
    </div>
  )
}
